import axios from 'axios';
const base = 'usernotify';

function getAll(query = null) {
    return axios.get(base, { params: query });
}

function getAllFull() {
    return axios.get(`${base}/all`);
}

function register(data) {
    return axios.post(base, data);
}

const UserNotifyService = { getAll, getAllFull, register };
export default UserNotifyService;
